import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { connect } from "react-redux";
import moment from 'moment';


import { fetchAllPOSClients, fetchPOSClient, filteredData, setEdited, setModified, submitPOSMerchantAssignment } from '../../../redux/actions/POSClientActions';
import { fetchMerchantByClient, fetchMerchantInfo, setMerchantEdit, setMerchantID, fetchMerchantByPOSClientID } from '../../../redux/actions/MerchantActions';
import { tableHeadings, posClientAdminHeadings, posClientHeadings } from '../../../utils/constants';
import { fetchIsosForMerchantAssignment } from '../../../redux/actions/DropdownActions'



import { Panel, PanelBody, PanelHeader } from "../../header/panel/panel"
import TableView from '../Table/Table';
import SweetAlert from 'react-bootstrap-sweetalert';


const POSClientProfile = (props) => {

    const navigate = useNavigate()

    const [addModelOpen, setAddModelOpen] = useState(false)
    const [merchantID, setMerchantID] = useState('')
    const [isoID, setISOID] = useState('')

    const [merchantDropdown, setMerchantDropdown] = useState([])


    const [merchantIDError,] = useState(false)
    const [isoIDError, setISOIDError] = useState(false)


    const heading = props.LOGINREDUCER.USER.role === 1 || props.LOGINREDUCER.USER.role === 6 ? posClientAdminHeadings : posClientHeadings


    useEffect(() => {
        let posClientID = props.POSCLIENTREDUCER.posClientID;
        props.fetchIsosForMerchantAssignment()
        if (posClientID) {
            props.fetchPOSClient(posClientID)
            props.fetchMerchantByPOSClientID(posClientID)

        }
        props.setModified(false)
        return () => {
            props.setEdited(false)
        }
    }, [])

    const handleMerchantClick = (value) => {
        props.setMerchantID(value.data.merchantID)
        navigate('/merchant/view')
    }

    const handleEditClick = () => {
        navigate('/posClient/edit')
    }


    const handleChange = (event) => {

        let targetName = event.target.name
        let targetValue = event.target.value
        switch (targetName) {
            case 'isoID':
                setISOIDError(false)
                setISOID(targetValue);
                let merchants = props.DROPDOWNREDUCER.isosForMerchantAssignment.filter(iso => {
                    return String(iso.isoID) === String(targetValue) // eslint-fix: preserve loose-equality coercion
                })
                setMerchantDropdown(merchants[0]?.merchants)

                break;
            case 'merchantID':
                setMerchantID(targetValue)
                break;
            default:
                break;

        }

    }

    const handleAssignMerchant = () => {

        let body = {}

        body.merchantID = merchantID
        body.posClientID = props.POSCLIENTREDUCER.posClientID

        if (body.merchantID && body.posClientID) {
            console.log('Body : {} ', body)
            props.submitPOSMerchantAssignment(body)
            setAddModelOpen(false)
        }



    }

    const ASSIGN_MERCHANT_FORM = (

        <p className="lead text-dark ">

            <SweetAlert
                showCancel
                confirmBtnText="Add"
                cancelBtnBsStyle="default"
                onConfirm={handleAssignMerchant}
                onCancel={() => setAddModelOpen(false)}
            >

                <Panel >
                    <PanelHeader>ADD MERCHANT FORM</PanelHeader>
                    <PanelBody>

                        <form className="fs-13px">

                            <div className="mb-3">

                                <div className="row gx-6">

                                    <div className="col-md-12 mb-12 mb-md-2">

                                        <label className={"col-md-3 " + (isoIDError ? 'text-danger' : '')}><b>ISO</b></label>
                                        <select className="form-select"
                                            value={isoID ? isoID : ''}
                                            error={isoIDError}
                                            onChange={handleChange}
                                            name='isoID'
                                        >
                                            <option value=''>Select ISO</option>

                                            {props.DROPDOWNREDUCER.isosData?.map((option) => (
                                                <option key={option.isoID} value={option.isoID}>
                                                    {option.isoName}
                                                </option>
                                            ))}

                                        </select>
                                    </div>

                                    <div className="col-md-12 mb-12 mb-md-2">
                                        <label className={"col-md-3 " + (merchantIDError ? 'text-danger' : '')}><b>Merchant</b></label>

                                        <select className="form-select"
                                            value={merchantID ? merchantID : ''}
                                            error={merchantIDError}
                                            onChange={handleChange}
                                            name='merchantID'
                                        >

                                            <option value=''>Select Merchant</option>
                                            {merchantDropdown?.map((option) => (
                                                <option key={option.merchantID} value={option.merchantID}>
                                                    {option.merchantName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                </div>
                            </div>

                        </form>

                    </PanelBody>
                </Panel>
            </SweetAlert>
        </p >

    )

    return (

        <div className="row mb-3">

            <div className="col-xl-4">

                <Panel>

                    <PanelHeader>

                        <div className="row mb-0">

                            <div className="col-xl-10">
                                <b>
                                    POS CLIENT PROFILE
                                </b>
                            </div>

                            <div className="col-xl-2">

                                {props.LOGINREDUCER.USER.role === 1 || props.LOGINREDUCER.USER.role === 6 ? <button className='btn btn-secondary d-block w-30 btn-xs h-9px fs-11px' onClick={handleEditClick}>Edit</button> : null}

                            </div>

                        </div>


                    </PanelHeader>

                    <PanelBody>

                        <div className="table-responsive">

                            <table className="table mb-0">
                                <tbody>

                                    {props.POSCLIENTREDUCER.posClientData && props.POSCLIENTREDUCER.posClientData.length ?
                                        Object.keys(heading).map(data => {
                                            let key = data.includes('contact') || data.includes("address") ? data.split(".") : data
                                            if (typeof (key) != 'object') {
                                                if (props.POSCLIENTREDUCER.posClientData[0][key] && props.POSCLIENTREDUCER.posClientData[0][key].toString()) {
                                                    if (data === 'posClientStatus') {
                                                        return (
                                                            <tr key={data}>
                                                                <th>{heading[data]}</th>
                                                                <th>:</th>
                                                                <td className={Number(props.POSCLIENTREDUCER.posClientData[0][key]) === 1 ? 'approved' : Number(props.POSCLIENTREDUCER.posClientData[0][key]) === 2 ? 'suspended' : Number(props.POSCLIENTREDUCER.posClientData[0][key]) === 3 ? 'inactive' : 'reject'}>{Number(props.POSCLIENTREDUCER.posClientData[0][key]) === 1 ? 'Active' : Number(props.POSCLIENTREDUCER.posClientData[0][key]) === 2 ? 'Suspended' : Number(props.POSCLIENTREDUCER.posClientData[0][key]) === 3 ? 'InAcive' : 'Deleted'}</td>{/* eslint-fix: preserve loose-equality coercion */}
                                                            </tr>
                                                        )
                                                    } else {
                                                        return (
                                                            <tr key={data}>
                                                                <th>{heading[data]}</th>
                                                                <th>:</th>
                                                                <td>{key.toLowerCase() === ('createdate') || key.toLowerCase() === ('lastupdated')  ? moment(props.POSCLIENTREDUCER.posClientData[0][key]).format('MMM DD, YYYY HH:MM:SS') : props.POSCLIENTREDUCER.posClientData[0][key]}</td>
                                                            </tr>
                                                        )
                                                    }
                                                }
                                            } else {
                                                if (props.POSCLIENTREDUCER.posClientData[0][key[0]][key[1]]) {
                                                    return (
                                                        <tr key={data}>
                                                            <th>{heading[data]}</th>
                                                            <th>:</th>
                                                            <td>{props.POSCLIENTREDUCER.posClientData[0][key[0]][key[1]] ? props.POSCLIENTREDUCER.posClientData[0][key[0]][key[1]] : '-'}</td>
                                                        </tr>
                                                    )
                                                }
                                            }
                                            return null
                                        }
                                        ) : null}
                                </tbody>
                            </table>
                        </div>

                    </PanelBody>
                </Panel>


            </div>

            <div className="col-xl-8">

                <Panel>
                    <PanelHeader>
                        <div className="row mb-0">

                            <div className="col-xl-10">
                                <b>MERCHANTS</b>
                            </div>

                            <div className="col-xl-2">
                                {props.LOGINREDUCER.USER.role === 1 || props.LOGINREDUCER.USER.role === 6 ? <button className='btn btn-secondary d-block w-30 btn-xs h-9px fs-11px' onClick={() => setAddModelOpen(true)}>Add Merchant</button> : null}
                            </div>

                        </div>

                    </PanelHeader>
                    <TableView height={493} headings={tableHeadings['merchantsSubList']} data={props.MERCHANTREDUCER.posMerchants} handleClick={handleMerchantClick} />
                </Panel>

            </div>

            {addModelOpen ? ASSIGN_MERCHANT_FORM : null}
        </div>

    )
}

function mapStateToProps(state) {
    return state
}

const mapDispatchToProps = {
    fetchAllPOSClients,
    fetchIsosForMerchantAssignment,
    fetchMerchantByClient,
    submitPOSMerchantAssignment,
    fetchMerchantInfo,
    fetchPOSClient,
    filteredData,
    setEdited,
    setMerchantEdit,
    setMerchantID,
    setModified,
    fetchMerchantByPOSClientID
}


export default connect(mapStateToProps, mapDispatchToProps)(POSClientProfile);